<template>
  <div v-if="uploads.length > 0">
    <p class="mb-6">Uploaded files till date</p>
    <el-collapse>
      <el-collapse-item v-for="file in uploads" :title="file.file_name" :name="file.id">
        <p>Started At: {{file.start}}</p>
        <p class="mb-4">Ended At: {{file.end}}</p>
        <el-alert
          title="Error Lists"
          type="error"
          v-if="Object.keys(file.details).length > 0">
          <p class="font-thin mb-2" v-for="row in file.details">
            Item <strong>{{row.product_name}}</strong> at row id <strong>{{row.row_number}}</strong> had this error <strong>{{row.error_message}}</strong>
          </p>
        </el-alert>
        <el-alert
          title="Upload Success"
          type="success"
          v-else
          show-icon>
          No errors.
        </el-alert>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'ProductsUploadsDetail',
  computed: {
    uploads() {
      return this.$store.state.InventoryModule.Products.csvUploads;
    },
  },
};
</script>

<style scoped>

</style>
